import * as React from "react";

const CoralRightSVG = ({ width = 80, style }) => {
  return (
    <svg
      width={width}
      height={width * 5}
      viewBox="0 0 200 1000"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <g clipPath="url(#clip0_2309_111)">
        <g opacity={0.8}>
          <path
            d="M75.1075 368.857C80.5372 371.157 92.9711 370.384 98.3873 363.314C103.804 356.243 101.089 345.774 95.659 343.475C86.1918 339.465 68.4305 343.118 63.0142 350.188C57.598 357.258 69.6778 366.557 75.1075 368.857Z"
            fill="url(#paint0_linear_2309_111)"
          />
          <path
            d="M133.779 343.87C128.874 345.743 123.234 347.898 118.207 349.818C115.677 344.396 112.792 338.215 104.269 337.893C98.9546 337.692 68.968 344.628 64.6822 340.132C62.4499 337.791 55.7197 325.99 67.0369 326.822C73.6914 327.31 77.3806 331.742 88.2837 324.766C89.3483 321.165 81.6439 319.437 77.4011 319.014C57.9289 312.269 65.5304 304.433 67.2101 302.769C71.6943 298.757 80.115 305.407 82.4037 307.216C92.8064 313.72 87.7607 306.876 82.6012 297.986C71.8931 288.66 90.1003 275.681 92.3813 276.854C99.7946 280.666 97.7613 309.714 99.0224 316.132C101.07 322.378 107.913 325.897 110.439 326.976C124.253 340.482 119.684 321.4 116.578 317.221C111.284 311.449 103.783 308.295 101.685 303.224C96.0235 289.543 105.612 280.202 109.547 284.087C115.735 290.195 111.392 302.336 114.591 305.841C128.683 321.285 126.223 310.47 125.928 308.155C125.492 304.744 114.251 289.628 114.477 283.92C114.764 276.655 126.615 274.948 127.507 280.181C130 294.813 131.421 303.802 134.096 293.995C135.109 290.283 136.042 282.699 140.204 281.71C145.146 280.537 152.794 283.884 152.664 290.369C152.628 292.144 145.03 297.449 140.353 303.835C132.275 316.692 140.663 320.539 146.967 310.209C149.341 306.318 151.105 299.88 152.224 298.873C155.685 295.763 164.466 302.943 164.408 305.27C163.986 322.038 148.454 319.896 138.489 326.097C129.98 331.391 130.59 337.036 133.779 343.87Z"
            fill="url(#paint1_linear_2309_111)"
          />
          <path
            d="M105.45 368.965C112.056 371.763 128.381 375.644 139.836 366.831C148.084 360.485 143.861 345.971 137.255 343.173C125.737 338.294 105.155 341.397 99.4267 348.875C93.6981 356.353 98.8438 366.167 105.45 368.965Z"
            fill="url(#paint2_linear_2309_111)"
          />
          <path
            d="M102.947 374.301C105.893 375.549 113.333 377.07 119.165 372.196C123.363 368.687 122.153 361.336 119.207 360.088C114.071 357.913 104.267 360.113 101.189 364.131C98.1101 368.15 100.001 373.053 102.947 374.301Z"
            fill="url(#paint3_linear_2309_111)"
          />
          <path
            d="M83.8683 372.545C87.0606 373.191 94.499 373.739 98.0053 370.135C100.53 367.54 96.5994 362.727 93.4071 362.081C87.8411 360.954 79.6507 363.028 78.3533 365.892C77.0558 368.756 80.6761 371.899 83.8683 372.545Z"
            fill="url(#paint4_linear_2309_111)"
          />
        </g>

 <path
        d="M166.079 709.892C176.298 709.447 166.326 734.033 159.203 747.353C155.642 754.013 179.102 735.417 180.298 739.894C182.007 746.288 175.5 750.309 155.923 762.159C151.619 764.765 150.73 774.964 151.641 778.375C148.103 779.32 144.565 780.264 140.705 781.295C139.754 777.735 141.216 765.154 133.1 761.859C118.572 755.962 114.642 754.684 119.614 748.789C123.592 744.073 129.007 746.966 143.124 755.528C143.439 753.141 142.282 749.831 136.575 745.631C127.238 738.758 115.399 733.015 119.614 726.866C132.126 721.241 137.325 740.7 145.094 735.82C149.52 733.039 124.409 712.568 137.918 708.961C153.035 704.925 149.782 728.859 156.764 727.908C161.087 727.319 153.816 710.426 166.079 709.892Z"
        fill="url(#paint5_radial_2309_111)"
      />
      <path
        d="M147.642 772.461C151.986 772.985 158.152 780.933 157.404 787.163C156.656 793.393 152.262 797.986 145.852 797.214C138.277 796.3 134.513 790.723 135.261 784.493C136.009 778.263 143.297 771.938 147.642 772.461Z"
        fill="#165741"
      />
      <path
        d="M145.424 783.776C130.286 782.009 115.763 769.471 142.574 771.527C135.94 769.852 137.678 763.092 144.398 764.955C148.184 755.245 158.704 735.656 167.402 735.182C209.395 732.893 266.258 695.367 287.15 728.655C316.758 748.367 329.43 886.648 314.43 902.799C307.406 917.445 170.025 914.994 125.333 917.431C125.061 912.447 114.411 913.025 108.604 914.084C89.7972 917.516 79.3253 907.534 91.4019 902.803C66.1577 908.807 56.4046 895.454 72.0805 890.526C47.4023 884.836 51.9806 852.928 89.0473 859.609C82.998 859.013 91.8498 839.276 108.309 843.192C102.638 838.503 101.047 826.37 113.251 823.483C92.6086 826.089 107.068 808.639 126.396 809.992C114.986 804.875 122.513 799.466 131.171 798.253C117.863 796.942 123.164 783.323 145.424 783.776Z"
        fill="url(#paint6_linear_2309_111)"
      />
      <path
        d="M122.313 855.331C133.256 855.746 132.029 887.158 119.387 890.559C108.445 890.143 98.2397 878.747 99.2135 870.127C100.187 861.507 111.371 854.915 122.313 855.331Z"
        fill="url(#paint7_linear_2309_111)"
      />
      <path
        d="M84.9974 860.898C94.2797 861.25 93.3294 887.098 82.6164 889.884C73.3341 889.532 62.1669 882.3 62.9681 875.208C63.7693 868.115 75.715 860.545 84.9974 860.898Z"
        fill="url(#paint8_linear_2309_111)"
      />
      <path
        d="M104.413 845.685C108.605 846.062 106.063 859.9 100.964 861.177C96.772 860.8 92.2847 856.697 93.2281 852.911C94.1715 849.125 100.222 845.308 104.413 845.685Z"
        fill="url(#paint9_linear_2309_111)"
      />
      <path
        d="M158.731 850.553C169.674 850.969 168.447 882.381 155.805 885.781C144.863 885.365 134.658 873.97 135.631 865.35C136.605 856.73 147.789 850.137 158.731 850.553Z"
        fill="url(#paint10_linear_2309_111)"
      />
      <path
        d="M138.188 820.631C149.131 821.047 147.904 852.459 135.262 855.86C124.32 855.444 114.115 844.048 115.088 835.428C116.062 826.808 127.246 820.215 138.188 820.631Z"
        fill="url(#paint11_linear_2309_111)"
      />
      <path
        d="M99.8661 755.024C104.265 744.044 75.5713 727.266 83.1221 717.754C94.8809 702.943 115.869 724.199 110.871 755.43C108.279 771.631 119.77 776.455 132.99 785.489C126.551 791.631 124.214 793.859 121.8 796.162C119.106 793.336 111.447 791.995 103.364 791.979C88.8965 791.95 72.3996 806.827 65.9868 798.084C62.9282 793.914 79.5333 780.592 99.9547 782.111C98.8847 779.874 74.6217 784.439 67.7278 783.608C58.3349 782.476 45.822 777.551 48.2342 767.855C51.9504 757.691 80.7848 777.397 85.2511 767.619C90.363 763.712 51.4615 751.27 53.6692 732.93C55.3724 718.78 75.6087 728.152 78.6725 737.818C83.1984 752.096 95.6406 751.72 99.8661 755.024Z"
        fill="url(#paint12_radial_2309_111)"
      />
      <path
        d="M128.446 810.458C130.158 816.061 127.705 825.849 121.833 828.612C115.96 831.374 108.893 826.066 107.18 820.463C104.195 810.693 108.151 805.823 114.023 803.06C119.895 800.297 126.733 804.855 128.446 810.458Z"
        fill="#0B7466"
      />
      <path
        d="M142.723 774.735C144.436 780.338 141.982 790.126 136.11 792.889C130.238 795.652 123.17 790.343 121.458 784.74C118.472 774.97 122.428 770.1 128.301 767.337C134.173 764.575 141.011 769.132 142.723 774.735Z"
        fill="#007867"
      />
      <path
        d="M105.063 791.68C109.408 792.204 115.574 800.151 114.826 806.381C114.078 812.611 109.684 817.205 103.274 816.432C95.6986 815.519 91.9345 809.942 92.6824 803.712C93.4304 797.482 100.719 791.156 105.063 791.68Z"
        fill="#165741"
      />
      <path
        d="M148.672 797.915C150.385 803.518 147.931 813.306 142.059 816.069C136.187 818.831 129.12 813.523 127.407 807.92C124.421 798.15 128.378 793.28 134.25 790.517C140.122 787.754 146.96 792.312 148.672 797.915Z"
        fill="#0A8877"
      />
      <path
        d="M120.977 783.609C125.833 784.195 131.647 791.044 130.749 798.52C129.852 805.996 122.583 811.268 117.727 810.682C109.26 809.662 107.708 803.326 108.606 795.85C109.503 788.374 116.121 783.024 120.977 783.609Z"
        fill="#1D654D"
      />
        <defs>
          <linearGradient
            id="paint0_linear_2309_111"
            x1={109.681}
            y1={350.336}
            x2={78.0946}
            y2={366.176}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#2A8F6F" />
            <stop offset={1} stopColor="#09726E" />
          </linearGradient>

          <linearGradient
            id="paint1_linear_2309_111"
            x1={100.829}
            y1={289.465}
            x2={123.15}
            y2={347.902}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#545E30" />
            <stop offset={1} stopColor="#09635F" />
          </linearGradient>

          <linearGradient
            id="paint2_linear_2309_111"
            x1={110.189}
            y1={346.784}
            x2={124.039}
            y2={370.478}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#2A6744" />
            <stop offset={1} stopColor="#0F796C" />
          </linearGradient>

          <linearGradient
            id="paint3_linear_2309_111"
            x1={117.141}
            y1={359.213}
            x2={109.563}
            y2={377.103}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#276945" />
            <stop offset={1} stopColor="#0A7066" />
          </linearGradient>

          <linearGradient
            id="paint4_linear_2309_111"
            x1={91.1678}
            y1={361.627}
            x2={88.7573}
            y2={373.535}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#357738" />
            <stop offset={1} stopColor="#0A7874" />
          </linearGradient>

          <radialGradient
            id="paint5_radial_2309_111"
            cx={0}
            cy={0}
            r={1}
            gradientTransform="matrix(9.11303 34.1056 -30.9235 8.25681 147.951 742.821)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0.586538} stopColor="#137D5A" />
            <stop offset={1} stopColor="#426E33" />
          </radialGradient>
           <linearGradient
        id="paint6_linear_2309_111"
        x1={165.197}
        y1={840.821}
        x2={168.857}
        y2={740.606}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#22AA74" />
        <stop offset={1} stopColor="#00808A" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_2309_111"
        x1={98.9891}
        y1={872.114}
        x2={129.32}
        y2={875.54}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#009085" />
        <stop offset={1} stopColor="#22AA75" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_2309_111"
        x1={65.2621}
        y1={874.686}
        x2={90.9921}
        y2={877.593}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#009085" />
        <stop offset={1} stopColor="#1AA378" />
      </linearGradient>
      <linearGradient
        id="paint9_linear_2309_111"
        x1={94.3138}
        y1={852.678}
        x2={105.594}
        y2={855.488}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#009085" />
        <stop offset={1} stopColor="#1AA378" />
      </linearGradient>
      <linearGradient
        id="paint10_linear_2309_111"
        x1={130.628}
        y1={868.87}
        x2={157.754}
        y2={867.391}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00A295" />
        <stop offset={1} stopColor="#1DA577" />
      </linearGradient>
      <linearGradient
        id="paint11_linear_2309_111"
        x1={110.085}
        y1={838.948}
        x2={137.211}
        y2={837.469}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00A295" />
        <stop offset={1} stopColor="#17A079" />
      </linearGradient>

          <radialGradient
            id="paint12_radial_2309_111"
            cx={0}
            cy={0}
            r={1}
            gradientTransform="matrix(32.7804 34.391 -29.4726 28.1113 88.253 762.502)"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#0B6B59" />
            <stop offset={1} stopColor="#187C54" />
          </radialGradient>

          <clipPath id="clip0_2309_111">
            <rect width={200} height={1000} fill="white" />
          </clipPath>
        </defs>
      </g>
    </svg>
  );
};

export default React.memo(CoralRightSVG, (prev, next) => prev.width === next.width);
